import React from 'react';
import CampaignDaysPlay from '../../CampaignDaysPlay/CampaignDaysPlay.jsx';
import Regions from '../../Regions/Regions.jsx';
import Environment from '../../Environment/Environment.jsx';
import styles from '../CampaignDetails.module.css';

const DenmarkCampaignView = ({ orderlinesData, campaignPromiseType, campaignType, showDaysGraph }) => (
  <>
    {showDaysGraph && (
      <div className={styles.chartCampaignDaysPlay}>
        <CampaignDaysPlay orderlinesData={orderlinesData} campaignPromiseType={campaignPromiseType} />
      </div>
    )}
    {showDaysGraph ? (
      <div className={styles.twoChartRow}>
        <Regions 
          orderlinesData={orderlinesData} 
          campaignPromiseType={campaignPromiseType} 
          campaignType={campaignType} 
          showDaysGraph={showDaysGraph} />
        <Environment 
          orderlinesData={orderlinesData} 
          campaignPromiseType={campaignPromiseType} 
          campaignType={campaignType} 
          showDaysGraph={showDaysGraph} />
      </div>
    ) : (
      <>
        <div className={styles.regionBlock}>
          <Regions 
            orderlinesData={orderlinesData} 
            campaignPromiseType={campaignPromiseType} 
            campaignType={campaignType} 
            showDaysGraph={showDaysGraph} />
        </div>
        <div className={styles.chartBelow}>
          <Environment 
            orderlinesData={orderlinesData} 
            campaignPromiseType={campaignPromiseType} 
            campaignType={campaignType} 
            showDaysGraph={showDaysGraph} />
        </div>
      </>
    )}
  </>
);

export default DenmarkCampaignView;
